import { render, staticRenderFns } from "./FTDB.vue?vue&type=template&id=1ed8ff68&scoped=true"
import script from "./FTDB.vue?vue&type=script&lang=js"
export * from "./FTDB.vue?vue&type=script&lang=js"
import style0 from "./FTDB.vue?vue&type=style&index=0&id=1ed8ff68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed8ff68",
  null
  
)

export default component.exports